import swiper from "swiper";

const topPageSwiper = new swiper('.swiper-container', {
   autoplay: {
    delay: 4500,
  },
  loop: true,
  slidesPerView: 1.2,
  spaceBetween: 8,
  centeredSlides: true,
  pagination: {
    el: ".swiper-pagination",
    clickable: true,
  },
})